import { StatusCodes } from "./Constants";

export class HttpRequestError extends Error {
    constructor(private uri: string,  private method: string, public statusCode: number, private data: string) {
        super();
        this.message = `The HTTP request encountered the following error
                        Method: ${this.method}
                        URI: ${this.uri}
                        StatusCode: ${this.statusCode}
                        Response: ${this.data}`;
    }
}

export class EndpointNotFoundError extends Error {
    constructor(private endpoint: string, public statusCode: number) {
        super();
        this.message = `Could not find the URI for the endpoint ${this.endpoint}`;
    }
}

export class NativeBindingError extends Error {
    constructor(private bindingName: string, public statusCode: number = StatusCodes.NativeBindingError) {
        super();
        this.message = `Native Binding not found for module or method ${this.bindingName}`;
    }
}
